import { makeStyles } from "@mui/styles";
import { APP_COLORS } from "../../enums";

export const useZoomPlayerStyles = makeStyles({
  container: {
    display: "flex",
    height: "100%",
    borderRadius: 8,
    position: "relative",
    flexDirection: "row",
    minHeight: "400px",
    "@media (max-width:1024px)": {
      flexDirection: "column",
      minHeight: "500px",
    },
    "@media (max-width:600px)": {
      minHeight: "450px",
    },
  },
  leftPane: {
    display: "flex",
    flexDirection: "column",
    flexBasis: "70%",
    minHeight: "300px",
    "@media (max-width:900px)": {
      flexBasis: "50%",
      minHeight: "250px",
    },
    "@media (max-width:600px)": {
      flexBasis: "55%",
      minHeight: "200px",
    },
  },
  leftPaneFull: {
    flexBasis: "100% !important",
  },
  playerHeader: {
    backgroundColor: "#fff",
    color: "#111",
    "@media (max-width:900px)": {
      display: "none",
    },
  },
  playerTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    "@media (max-width:600px)": {
      fontSize: "1.2rem",
      padding: "8px 12px",
    },
  },
  videoContainer: {
    position: "relative",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 480,
    flex: 1,
    width: "100%",
    "@media (max-width:900px)": {
      minHeight: 250,
    },
    "@media (max-width:600px)": {
      minHeight: 200,
    },
  },
  videoContainerFull: {
    flexBasis: "100% !important",
  },
  videoEl: {
    width: "100%",
    height: "100%",
    objectFit: "contain" as any,
    outline: "none",
    border: 0,
    borderRadius: 16,
    
    "@media (max-width:900px)": {
      "&::-webkit-media-controls-enclosure": {
        transform: "scale(0.92)",
        transformOrigin: "right bottom",
      },
      "&::-webkit-media-controls-play-button": {
        transform: "scale(0.9)",
      },
      "&::-webkit-media-controls-timeline": {
        height: 2,
      },
      "&::-webkit-media-controls-volume-slider": {
        width: 60,
      },
      "&::-webkit-media-controls-mute-button": {
        transform: "scale(0.9)",
      },
      "&::-webkit-media-controls-current-time-display, &::-webkit-media-controls-time-remaining-display":
      {
        fontSize: 10,
      },
    },
    "@media (max-width:600px)": {
      "&::-webkit-media-controls-enclosure": {
        transform: "scale(0.86)",
        transformOrigin: "right bottom",
      },
      "&::-webkit-media-controls-play-button": {
        transform: "scale(0.85)",
      },
      "&::-webkit-media-controls-volume-slider": {
        width: 52,
      },
      "&::-webkit-media-controls-mute-button": {
        transform: "scale(0.85)",
      },
      "&::-webkit-media-controls-current-time-display, &::-webkit-media-controls-time-remaining-display":
      {
        fontSize: 9,
      },
    },
  },
  loadingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000",
    zIndex: 2,
  },
  progressBar: { width: 200 },
  errorOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.8)",
    zIndex: 3,
    gap: 8,
    paddingInline: 16,
    textAlign: "center" as const,
  },
  retryChip: {
    color: "#fff !important",
    borderColor: "rgba(255,255,255,0.7) !important",
    borderWidth: "1px !important",
    borderStyle: "solid !important",
  },
  bufferingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 3,
  },
  spinner: {
    width: 50,
    height: 50,
    border: "3px solid rgba(25, 118, 210, 0.3)",
    borderTop: "3px solid #1976d2",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: 8,
  },
  spinnerSmall: {
    width: 12,
    height: 12,
    border: "2px solid rgba(25, 118, 210, 0.3)",
    borderTop: "2px solid #1976d2",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginLeft: 4,
  },
  controlsBar: {
    position: "absolute",
    bottom: 11,
    left: 64,
    display: "none",
    gap: 8,
    zIndex: 5,
    borderRadius: 8,
    padding: 4,
    "@media (max-width:900px)": {
      bottom: 8,
      left: 8,
      gap: 6,
    },
    "@media (max-width:600px)": {
      gap: 4,
      bottom: 6,
      left: 6,
      padding: 2,
    },
  },
  iconBtn: {
    "@media (max-width:900px)": {
      padding: 6,
      width: 36,
      height: 36,
      "& svg": {
        fontSize: 20,
      },
    },
    "@media (max-width:600px)": {
      padding: 4,
      width: 32,
      height: 32,
      "& svg": {
        fontSize: 18,
      },
    },
  },
  iconActive: {
    color: "#1976d2 !important",
  },
  iconInactive: {
    color: "#eaeaea !important",
  },
  iconDisabled: {
    color: "#d0d0d0 !important",
    backgroundColor: "rgba(0,0,0,0.6) !important",
  },
  settingsPanel: {
    position: "absolute",
    top: 60,
    right: 16,
    padding: 16,
    borderRadius: 4,
    minWidth: 200,
    zIndex: 10,
  },
  settingsTitle: {
    color: "#fff",
    marginBottom: 8,
    fontWeight: 500,
  },
  settingsChips: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap" as any,
  },
  transcriptPanel: {
    flexBasis: "30%",
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "90vh",
    minHeight: "300px",
    overflow: "hidden",
    "@media (max-width:900px)": {
      borderLeft: "none",
      borderTop: "1px solid #e0e0e0",
      flexBasis: "auto",
      height: "auto",
      maxHeight: "350px",
      minHeight: "250px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
    "@media (max-width:600px)": {
      flexBasis: "auto",
      maxHeight: "300px",
      minHeight: "200px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
  },
  transcriptHeader: {
    padding: 10,
    flexShrink: 0,
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    "@media (max-width:600px)": {
      padding: 12,
    },
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: "#ffffff",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#d1d5db",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#94a3b8",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1976d2",
      borderWidth: 2,
    },
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
    "@media (max-width:600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 8,
      marginBottom: 12,
    },
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    "@media (max-width:600px)": {
      gap: 4,
    },
  },
  downloadBtn: {
    textTransform: "none" as any,
    paddingInline: 8,
    minWidth: 80,
    color: APP_COLORS.secondaryDark,
    fontSize: "0.85rem",
    "@media (max-width:600px)": {
      minWidth: 70,
      paddingInline: 6,
      fontSize: "0.75rem",
    },
  },
  transcriptScroll: {
    flex: 1,
    overflowY: "auto" as any,
    overflowX: "hidden" as any,
    minHeight: 600,
    isolation: "isolate",
    position: "relative",
    "@media (max-width:900px)": {
      maxHeight: "inherit",
      padding: 6,
      minHeight: 180,
    },
    "@media (max-width:600px)": {
      padding: 4,
      minHeight: 160,
    },
  },
  transcriptItem: {
    padding: 12,
    marginBottom: 4,
    borderRadius: 4,
    cursor: "pointer",
    transition: "none",
    "&:hover": {
      backgroundColor: "#f3f6f9",
    },
    "@media (max-width:600px)": {
      padding: 8,
      marginBottom: 2,
    },
  },
  transcriptItemActive: {
    backgroundColor: "#e3f2fd",
    borderLeft: "3px solid #1976d2",
  },
  transcriptItemSeeking: {
    backgroundColor: "#fff3e0",
    borderLeft: "3px solid #ff9800",
    opacity: 0.8,
  },
  rowCenterGap8: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  rowCenterGap8Mb4: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 4,
  },
  speakerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  speakerAvatar: {
    width: 28,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "rgba(25,118,210,0.12)",
    color: "#1976d2",
  },
  speakerName: {
    color: "#222",
    fontWeight: 600,
    fontSize: "0.9rem",
    "@media (max-width:600px)": {
      fontSize: "0.8rem",
    },
  },
  timeCaption: {
    color: "#7a7a7a",
    fontSize: "0.8rem",
  },
  speakerChipActive: {
    backgroundColor: "#1976d2 !important",
    color: "#fff !important",
  },
  speakerChip: {
    backgroundColor: "#e0e0e0 !important",
    color: "#666 !important",
    fontSize: "0.75rem",
  },
  transcriptText: {
    color: "#333",
    fontWeight: 400,
    lineHeight: 1.4,
    "@media (max-width:600px)": {
      fontSize: "0.85rem",
      lineHeight: 1.3,
    },
  },
  transcriptTextActive: {
    color: "#1976d2",
    fontWeight: 600,
    lineHeight: 1.4,
    "@media (max-width:600px)": {
      fontSize: "0.85rem",
      lineHeight: 1.3,
    },
  },
  overlayWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    bottom: 60,
    zIndex: 5,
    pointerEvents: "none" as any,
    padding: "0 16px",
    "@media (max-width:900px)": {
      bottom: 50,
      padding: "0 12px",
    },
    "@media (max-width:600px)": {
      bottom: 40,
      padding: "0 8px",
    },
  },
  overlayBox: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "#fff",
    padding: "12px 16px",
    borderRadius: 8,
    backdropFilter: "blur(10px)",
    maxWidth: "80%",
    width: "max-content",
    textAlign: "center" as const,
    maxHeight: 120,
    overflow: "hidden",
    pointerEvents: "auto" as any,
    "@media (max-width:900px)": {
      maxWidth: "92%",
      padding: "8px 12px",
      maxHeight: 100,
    },
    "@media (max-width:600px)": {
      maxWidth: "95%",
      padding: "6px 10px",
      maxHeight: 80,
      fontSize: "0.85rem",
    },
  },
  captionRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
    justifyContent: "center",
  },
  captionChip: {
    backgroundColor: "rgba(25,118,210,0.8)",
    color: "#fff",
    padding: "2px 8px",
    borderRadius: 12,
    fontSize: "0.7rem",
    fontWeight: 600,
  },
  captionTime: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "0.7rem",
  },
  captionText: {
    color: "#fff",
    lineHeight: 1.4,
    fontSize: "0.9rem",
    fontWeight: 500,
    textAlign: "center" as const,
    "@media (max-width:600px)": {
      fontSize: "0.8rem",
      lineHeight: 1.3,
    },
  },
  textWhite: { color: "#fff" },
  textMuted: { color: "#bbb" },

  summaryWrapper: {
    backgroundColor: "#fff",
    color: "#111",
    padding: 16,
    flexShrink: 0,
    overflow: "scroll",
    "@media (max-width:900px)": {
      padding: 12,
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
    "@media (max-width:600px)": {
      padding: 8,
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
  },
  summaryTitle: {
    fontWeight: 700,
    marginBottom: 8,
    "@media (max-width:600px)": {
      fontSize: "1.1rem",
      marginBottom: 6,
    },
  },
  summarySectionTitle: {
    fontWeight: 600,
    fontSize: "0.95rem",
    marginTop: 8,
    marginBottom: 4,
    "@media (max-width:600px)": {
      fontSize: "0.9rem",
      marginTop: 6,
      marginBottom: 3,
    },
  },
  summaryList: {
    margin: 0,
    paddingLeft: 18,
    "@media (max-width:600px)": {
      paddingLeft: 14,
    },
  },
  summaryItem: {
    fontSize: 13,
    "@media (max-width:600px)": {
      fontSize: 12,
      lineHeight: 1.4,
    },
  },
  resumeBar: {
    display: "flex",
    justifyContent: "center",
    padding: 8,
    borderTop: "1px solid #e0e0e0",
    backgroundColor: "#fff",
  },
  resumeBtn: {
    textTransform: "none" as any,
    backgroundColor: "#1976d2 !important",
    color: "#fff !important",
    fontWeight: 600,
    borderRadius: 999,
    paddingInline: 14,
    paddingBlock: 6,
  },
});
